import { HttpErrorIgnore } from '../../../global';
import utilSvc from '../utilSvc';
import validSvc from '../validSvc';
import { ngDelegate } from '../services/ng.delegate';
import { binaryFileType, BinaryFileType } from '../services/apiSvc';
import { useCallback } from 'react';

type UseGetExcelReturn = {
    handleGetExcel: () => void;
};

type UseExcelProps = {
    waiting: boolean;
    setWait: (waiting: boolean) => void;
    getExcel: () => Promise<HttpErrorIgnore | undefined>;
};

export const useGetExcel = ({ waiting, setWait, getExcel }: UseExcelProps): UseGetExcelReturn => {
    const okServerExcel = useCallback(
        (binaryData: any): void => {
            // convert binary stream to blob and save
            try {
                const _excelBlob = new Blob([binaryData], { type: binaryFileType(BinaryFileType.Excel) });
            } catch (err) {
                throw err;
            } finally {
                ngDelegate.wait(false);
                setWait(false);
                return;
            }
        },
        [setWait],
    );

    const errServerExcel = useCallback(
        (res: any): void => {
            ngDelegate.wait(false);
            setWait(false);

            if (!!res) {
                ngDelegate.warn('Create Excel Error', 'errServerExcel', utilSvc.http.safeResponse(res));
            }
        },
        [setWait],
    );

    const handleGetExcel = useCallback((): void => {
        if (waiting) {
            return;
        }

        if (!validSvc.blobSupported()) {
            ngDelegate.warn(
                'Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser',
                'errServerExcel',
            );
            ngDelegate.wait(false);
            setWait(false);
            return;
        }

        ngDelegate.wait(true, true);
        setWait(true);

        getExcel().then(okServerExcel, errServerExcel);
    }, [errServerExcel, getExcel, okServerExcel, setWait, waiting]);

    return {
        handleGetExcel,
    };
};
